/* 🤖 this file was generated by svg-to-ts */
export const siriusCalendarBlank: {
  name: 'calendar_blank';
  data: string;
} = {
  name: 'calendar_blank',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 2.25a.75.75 0 0 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3h-2.25v-.75ZM19.5 7.5v-3h-2.25v.75a.75.75 0 0 1-1.5 0V4.5h-7.5v.75a.75.75 0 0 1-1.5 0V4.5H4.5v3h15ZM4.5 9h15v10.5h-15V9Z" fill="currentColor"/></svg>`
};
